<template>
  <div class="withdrawalSetting">
      <el-form :model="form" ref="form" label-width="180px" style="margin:50px auto;width:80%">
        <el-form-item label="最小提现金额">
            <el-input v-model="form.minCash" style="width:80%;float:left">
                <template slot="append">元</template>
            </el-input>
        </el-form-item>
        <el-form-item label="提现手续费">
            <el-input v-model="form.withdrawalFee" style="width:80%;float:left">
                <template slot="append">%</template>
            </el-input>
        </el-form-item>
        <el-form-item label="提现方式">
            <el-checkbox-group v-model="form.checkList" style="float:left">
                <el-checkbox label="0">微信</el-checkbox>
                <el-checkbox label="1">支付宝</el-checkbox>
            </el-checkbox-group>
        </el-form-item>
        <el-form-item label="提现说明">
            <vue-ueditor-wrap v-model="form.content" :config="myConfig"></vue-ueditor-wrap>
        </el-form-item>
      </el-form>
      <div style="margin-bottom:10px">
          <el-button type="primary" @click="submit" size="small">提交</el-button>
      </div>
  </div>
</template>

<script>
import {withdrawalSettings, saveWithdrawalSettings} from '../../service/distribution'
import qs from 'qs'
import VueUeditorWrap from 'vue-ueditor-wrap'
export default {
    name: 'withdrawalSetting',
    components: { VueUeditorWrap  },
    data() {
      return {
        form:{
            checkList:[],
            withdrawalFee:"",
            minCash:""
        },
        myConfig: {
            // 编辑器不自动被内容撑高
            autoHeightEnabled: false,
            // 初始容器高度
            initialFrameHeight: 400,
            // 初始容器宽度
            initialFrameWidth: '80%',
            // 上传文件接口（这个地址是我为了方便各位体验文件上传功能搭建的临时接口，请勿在生产环境使用！！！）
            //serverUrl: 'http://35.201.165.105:8000/controller.php',
            serverUrl: 'https://api.goodyiyao.cn/index.php/api/File_logic/upload?action=config&action=uploadimage&encode=utf-8&path_type=withdrawal',
            // UEditor 资源文件的存放路径，如果你使用的是 vue-cli 生成的项目，通常不需要设置该选项，vue-ueditor-wrap 会自动处理常见的情况，如果需要特殊配置，参考下方的常见问题2
            UEDITOR_HOME_URL: '/ue/'
        },
      }
    },
    created(){
        withdrawalSettings().then(res=>{
            this.form.minCash = res.mix_price
            this.form.withdrawalFee = res.procedure
            this.form.content = res.content
            res.type.length == 3?this.form.checkList = [res.type[0],res.type[2]]:this.form.checkList = [res.type]
        })
    },
    methods:{
        changeresource(){
            this.form.commission = []
            if(parseInt(this.form.resource)!=6){
                let i= 0
                for(let i=0; i<parseInt(this.form.resource); i++){
                    this.form.commission.push({id:i+1,commission:""})
                }
            }
        },
        submit(){
            let type = ""
            this.form.checkList.length>1?type = this.form.checkList[0]+","+this.form.checkList[1]:type = this.form.checkList[0]
            let data = {
                mix_price:this.form.minCash,
                procedure:this.form.withdrawalFee,
                type:type,
                id:1,
                content:this.form.content
            }
            saveWithdrawalSettings(data).then(()=>{
                this.$message.success('保存成功')
            })
        }
    }
  }
</script>

<style lang="scss" scoped>
.el-radio{
    font-size: 24px;
}
.withdrawalSetting{
    background-color:#fff;
    font-size:24px;
}
</style>